export default __webpack_public_path__ + "assets/img/ict-postit.dbd6850f5d691164c10f6cfed79945ad.svg";